import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { roundFloat } from 'src/core/utils/formater';

const tText = 'T7_2_TailanZuruu.tableText';
const hText = 'T7_2_TailanZuruu.headerText';

export const customColumns = ({ t = null, editAction = () => {} }) => [
  {
    dataIndex: 'text',
    align: 'left',
    width: 50,
    render: (_, row, index) => {
      if (row?.mor_type === 'sum') {
        return {
          children: (
            <span className="fw-600">{t(`${tText}.${index}`, row?.text)}</span>
          ),
          props: {
            colSpan: row?.title ? 0 : 2,
          },
        };
      }
      return {
        props: {
          colSpan: row?.title ? 0 : 1,
        },
      };
    },
  },
  {
    title: t(`${hText}.${'uzuulelt'}`, 'ҮЗҮҮЛЭЛТҮҮД'),
    dataIndex: 'text',
    align: 'left',
    titleAlign: 'center',
    width: 534,
    render: (_, row, index) => {
      if (row?.mor_type === 'sum') {
        return {
          props: {
            colSpan: 0,
          },
        };
      }
      return {
        children: <span>{t(`${tText}.${index}`, row?.text)}</span>,
        props: {
          colSpan: row?.title && 0,
        },
      };
    },
  },
  {
    title: t(`${hText}.${'mur'}`, 'МӨР'),
    dataIndex: 'mur',
    align: 'center',
    titleAlign: 'center',
    width: 50,
  },
  {
    title: t(`${hText}.${'dun'}`, 'ДҮН'),
    dataIndex: 'dun',
    align: 'right',
    titleAlign: 'center',
    width: 150,
    render: (_, row) => {
      if (row?.mor_type === 'sum') {
        return {
          children: <span className="fw-600">{roundFloat(row?.dun)}</span>,
          props: {
            colSpan: row?.title && 0,
          },
        };
      }
      return {
        children: roundFloat(row?.dun),
        props: {
          colSpan: row?.title && 0,
        },
      };
    },
  },
  {
    align: 'center',
    width: 30,
    render: (_, row) => (
      row?.dun_type && (
        <div>
          <EditOutlined onClick={() => editAction(row)} />
        </div>
      )
    ),
  },
];
